module.exports = __webpack_public_path__ + "static/fipcbiglove2-6bef6ceb4ef5343bc2fd2052395e616f.jpeg";